/// <amd-module name="CodeCoverage/CodeCoverageCiFileCoveragePane/CodeEditorGutterAdornments/CodeEditor.GutterAdornments" />
import {
    GutterAdornment,
    IAdornmentControlManager,
    IMonacoAdornmentControl
} from "CodeCoverage/CodeCoverageCiFileCoveragePane/CodeEditorGutterAdornments/AdornmentContracts";
import { GutterAdornmentsWidget } from "CodeCoverage/CodeCoverageCiFileCoveragePane/CodeEditorGutterAdornments/GutterAdornmentsWidget";

// A "decoration" adornment for GUTTER adornments, which allows line numbers in the editor to be highlighted
class MonacoGutterAdornmentControl implements IMonacoAdornmentControl {
    constructor(private adornment: GutterAdornment, private gutterAdornmentWidget: GutterAdornmentsWidget) {}

    public show() {
        this.gutterAdornmentWidget.addAdornment(this.adornment);
    }

    public dispose() {
        this.gutterAdornmentWidget.removeAdornment(this.adornment);
    }
}

export class MonacoAdornmentControlManager implements IAdornmentControlManager {
    private _editor: any;
    private _adornmentControls: IMonacoAdornmentControl[];
    private _editorGutterWidget: GutterAdornmentsWidget;

    constructor(editor: any) {
        this._editor = editor;
        this._adornmentControls = [];
        this._editorGutterWidget = this._addGutterAdornmentWidgetToEditor();
    }

    public dispose() {
        this.removeAdornments();
    }

    public getEditor() {
        return this._editor;
    }

    // Set and draw adornments onto the editor
    public setAdornments(adornments: GutterAdornment[]) {
        this.removeAdornments();
        this.addAdornments(adornments);
    }

    // Add adornments to the editor
    public addAdornments(adornments: GutterAdornment[]) {
        if (adornments && adornments.length) {
            adornments.forEach(adornment => {
                if (this._editor) {
                    const adornmentControl = this._createAdornmentControl(adornment);
                    this._adornmentControls.push(adornmentControl);
                    adornmentControl.show();
                }
            });
        }
    }

    // Remove any adornments from the editor
    public removeAdornments() {
        this._adornmentControls.forEach(adornmentControl => {
            adornmentControl.dispose();
        });
        this._adornmentControls = [];
    }

    /** Creates a single adornment control */
    private _createAdornmentControl(adornment: GutterAdornment): IMonacoAdornmentControl {
        // Create a gutter adornment control
        const widget = this._editorGutterWidget;
        return new MonacoGutterAdornmentControl(adornment, widget);
    }

    private _addGutterAdornmentWidgetToEditor(): GutterAdornmentsWidget {
        const editor = this.getEditor();
        const gutterAdornmentWidget = new GutterAdornmentsWidget(editor);
        editor.addOverlayWidget(gutterAdornmentWidget);
        return gutterAdornmentWidget;
    }
}
